import Cookies from "js-cookie";
import { toast } from "react-toastify";
//import dotenv from 'dotenv';

const BASE_URI = process.env.REACT_APP_BASE_URI;
//const BASE_URI = "https://backend.bagh-e.com";
// const BASE_URI = "http://localhost:3000";


export const apiHelper = async (
  endPoint,
  method,
  body,
  state1,
  state2,
  state3,
  dispatch,
  isFile = false,
  isToast = true,
  isToken = false
) => {
  try {
    console.log("API Call:", {
      endPoint, body})
    dispatch(state1());
    const response = await fetch(`${BASE_URI}/${endPoint}`, {
      method: method,
      headers: {
        ...(!isFile && { "Content-Type": "application/json" }),
        ...(isToken && {
          Authorization: `Bearer ${Cookies.get("auth-token")}`,
        }),
      },
      ...(method === "POST" && {
        body: isFile && method === "POST" ? body : JSON.stringify(body),
      }),
      ...(method === "PUT" && {
        body: isFile && method === "PUT" ? body : JSON.stringify(body),
      }),
    });
    const data = await response.json();
    dispatch(state3());
    if (response.status === 500) {
      // single generic error toast for 500
      toast.error(data?.message || "Internal Server Error");
      return false;
    }
    if (response.status >= 400 && response.status < 500) {
      // if (
      //   endPoint === "user/login" &&
      //   data?.message === "ALREADY LOGGED IN ON SOME OTHER DEVICE"
      // ) {
        // localStorage.setItem('token', data.token);
        // localStorage.setItem('token', data.token);
        // Cookies.set("auth-token", data?.data?.token);
        //return data;
      //           return {
      //     success: false,
      //     error: data?.message,
      //     userId: data?.data?.user?.id,
      //   };
      // }
      if (
        endPoint === "user/login" &&
        data?.message === "ALREADY LOGGED IN ON SOME OTHER DEVICE"
      ) {
        dispatch(state2(data));
        // Force login by setting the new token
        Cookies.set("auth-token", data?.data?.token); // Save the new token
        return {
          success: true, // Mark login as successful
          error: null,
          newToken: data?.data?.token, // Pass the new token
          userId: data?.data?.user?.id,
        };
      }
      
       else if (endPoint === "user/login") {
        toast.error(data?.message);
        return { success: false, error: data?.message };
        
      }
      if (
        endPoint.startsWith("order/farmer/") ||
        endPoint.startsWith("farmer/farms/") ||
        endPoint.startsWith("order/supplier/")
      ) {
        return false;
      }
      if (
        endPoint.includes("get-rating") &&
        (response.status === 404 || /resource\s*not\s*found/i.test(data?.message || ""))
      ) {
        //toast.error("Rating not found");
        return false;
      }
      toast.error(data?.message || "Something went wrong");
      return false;
    }
    if ([200, 201, 204].includes(response.status)) {
      dispatch(state2(data));
  
      if (endPoint === "user/login"
        //|| endPoint === "otp/verifyforgototp"
      ) {
         localStorage.setItem('token', data.token);
        Cookies.set("auth-token", data?.data?.token);
      }
      if (isToast && !endPoint.startsWith("admin/getadmindata/")) {
        // single success toast per API call
        toast.dismiss();
        toast.success(data.message || "Success");
      }
      return data;
    }
  } catch (error) {
    dispatch(state3());
    toast.error(error.message);
    return false;
  }
};
